"use client";

import { motion } from 'framer-motion';
import Image from 'next/image';
import { GlassContainer } from '@/components/misc/glass-container';
import { cn } from '@/lib/utils';
import { DebugEditButton } from '@/components/mcp/debug/DebugEditButton';


const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.8 }
  }
};

export function AboutHero() {
  return (
    <section 
      className={cn(
        "relative h-[900px] overflow-hidden pt-24",
        "bg-background"
      )}
      aria-label="About Hero section"
    >
      {/* Background Image */}
      <div className="absolute inset-0 group">
        <Image
          src="/hero-about.png"
          alt="Decorative background image"
          fill
          priority
          className="object-cover object-center"
          sizes="100vw"
          quality={90}
          aria-hidden="true"
        />
        
        {/* Debug edit button - only shown in debug mode and on hover */}
        <DebugEditButton 
          imageName="hero-about"
          imageUrl="/hero-about.png"
        />
      </div>

      {/* Content Container */}
      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 h-full">
        <div className="relative z-10 h-full flex flex-col justify-center">
          <motion.div 
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            className="relative max-w-[760px]"
          >
            <GlassContainer intensity="medium">
              <h1 className="text-h2 mb-6">
                Über uns
              </h1>
              <div className="text-body-lg">
                <div className="mb-6 text-foreground/80">
                  <h2 className="text-h3 mb-4">
                    Die Vision hinter Umynd - skalierte Menschlichkeit und faire Chancen für Alle
                  </h2>
                  <p>
                    Recruiting ist ineffizient und unpersönlich – das ist keine neue Erkenntnis. 
                    Aber der Weg zu einer echten Lösung fehlte bisher. Umynd ändert das. Wir nutzen die Kraft moderner KI-Technologie und menschlicher Expert:innen, um Recruiting wieder menschlicher zu gestalten. 
                    Wir nennen das &apos;skalierte Menschlichkeit&apos;. Unser Ziel ist es, den Recruiting-Prozess für Kandidaten und Unternehmen fairer, effizienter und wertschätzender zu machen. 
                    Wir glauben, dass Technologie und Menschlichkeit sich nicht ausschließen, sondern ergänzen können.
                  </p>
                </div>
              </div>
            </GlassContainer>
          </motion.div>
        </div>
      </div>
    </section>
  );
} 